import { render, staticRenderFns } from "./TodoBox.vue?vue&type=template&id=2944c2b0&scoped=true"
import script from "./TodoBox.vue?vue&type=script&lang=js"
export * from "./TodoBox.vue?vue&type=script&lang=js"
import style0 from "./TodoBox.vue?vue&type=style&index=0&id=2944c2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2944c2b0",
  null
  
)

export default component.exports